import BaseApi from '../BaseApi';

class OrderApi extends BaseApi {
  bulkSkip(data = {}) {
    return this.post('orders/bulk-skip', data);
  }

  unskip(data = {}) {
    return this.post('orders/unskip', data);
  }

  bulkUnskip(data = {}) {
    return this.post('orders/bulk-unskip', data);
  }

  protected getSpecificApiPrefix(): string {
    return 'v2/managers/';
  }
}

export default OrderApi;
